import Modal from "../modal";

export interface QuizPopupParams {
    code: string;
}

export class QuizPopup {
    code: string;

    constructor(params: QuizPopupParams) {
        this.code = params.code;
    }

    show(): void {
        const modal = new Modal({
            id: `modal-quiz-${this.code}`,
            className: 'modal-quiz',
            onAfterHide: (e) => {
                e.destroy();
                $('body').removeClass('modal-announcement-open')
            },
            onAfterShow: () => {
                $('body').addClass('modal-announcement-open')
            }
        }, this.getContent());

        modal.show();
    }

    protected getContent(): string {
        return `<kinotoday-quiz quiz-code="${this.code}"></kinotoday-quiz>`;
    }
}
